module.exports = __webpack_public_path__ + "3e765f25d0f2e1c32a1aa13ac4cb2c5d.png";